(function ($, window, Drupal) {

    'use strict';

    /**
     * Toggles media-query specific body classes.
     *
     * You can define new media queries to listen to by writing them into the
     * Drupal.settings.omegaSettings.mediaQueries array.
     */
    Drupal.behaviors.omegaMediaQueryClasses = {
        handler: function (name, mql) {
            if (mql.matches) {
                $('body').removeClass(name + '-inactive').addClass(name + '-active');
            }
            else {
                $('body').removeClass(name + '-active').addClass(name + '-inactive');
            }
        },
        attach: function (context, settings) {
            var behavior = this;
            $(context).find('body').once('omega-mediaqueries').each(function () {
                var mediaQueries = {
                    'mobile': 'all and (max-width: 767px)',
                    'tablet': 'all and (min-width: 767px)',
                    'desktop': 'all and (min-width: 900px)'
                };

                $.each(mediaQueries, function (index, value) {
                    var mql = window.matchMedia(value);

                    // Initially, check if the media query applies or not and add the
                    // corresponding class to the body.
                    behavior.handler(index, mql);

                    // React to media query changes and toggle the class names.
                    mql.addListener(function (mql) {
                        behavior.handler(index, mql);
                    });
                });
            });
        }
    };

    Drupal.behaviors.OysterThemeScrollDown = {
        attach: function (context, settings) {
            jQuery("#block-homepagebanner .more").click(function () {
                jQuery('html, body').stop(true, false).animate({
                    scrollTop: jQuery("#node-1").offset().top - 100
                }, 1500);
                return false;
            });

        }
    };

    Drupal.behaviors.OysterThemeHPPopup = {
        attach: function (context, settings) {
            jQuery('.block-views-blockhomepage-popup-block-1 .block__content .btn').on('click', function () {
                if ($.isFunction(jQuery.cookie)) {
                    jQuery.cookie('oyster_hp_popup', 1, {expires: 365});
                }
                jQuery('.block-views-blockhomepage-popup-block-1').fadeOut();
                return false;
            });
            if ($.isFunction(jQuery.cookie)) {
                if (jQuery.cookie('oyster_hp_popup') == 1) {
                    jQuery('body').removeClass('hp-popup');
                }
                else {
                    jQuery('body').addClass('hp-popup');
                }
            }

        }
    };

    Drupal.behaviors.OysterThemeFlexslider = {
        attach: function (context, settings) {
            if ($.isFunction($.fn.flexslider)) {
                $('.block-homepage-banner', context).once('flexdone').flexslider({
                    fadeFirstSlide: false
                });

                if ($('.paragraph--type--image-slider .field--name-field-slider-image > .field__item').length > 1) {
                    $('.paragraph--type--image-slider', context).once('flexdone').flexslider({
                        fadeFirstSlide: false,
                        directionNav: false,
                        selector: '.field--name-field-slider-image > .field__item'
                    });
                }

                if($('.paragraph--type--page-quotes .field--name-field-quote-item > .field__item').length > 1) {
                    $('.paragraph--type--page-quotes', context).once('flexdone').flexslider({
                        fadeFirstSlide: false,
                        selector: '.field--name-field-quote-item > .field__item',
                        controlNav: false,
                    });
                }
            }
        }
    };

    Drupal.behaviors.OysterThemeSwipebox = {
        attach: function (context, settings) {
            if ($.isFunction($.fn.swipebox)) {
                $('.swipebox').swipebox();
                $('.field--name-field-gallery-image  a').swipebox();
            }
        }
    };

    Drupal.behaviors.OysterThemeSelect2 = {
        attach: function (context, settings) {
            if ($.isFunction($.fn.select2)) {
                $('select').select2();
            }
        }
    };

    Drupal.behaviors.OysterThemerBreadcrumbs = {
        attach: function (context, settings) {
            if ($.isFunction($.fn.rcrumbs)) {
                $("#block-oystertheme-breadcrumbs .breadcrumb").once('rcrumbs-done').rcrumbs({ellipsis: false});

            }
        }
    };

    Drupal.behaviors.OysterThemeHistory = {
        attach: function (context, settings) {
            var title = $('.oyster-history-block');
            if ((typeof title !== 'undefined') && (title.length > 0)) {
                var x = document.getElementsByClassName("oyster-history-block");
                $(x).each(function () {
                    new cbpScroller($(this)[0]);
                });
            }
        }
    };

    Drupal.behaviors.OysterThemeSearchUI = {
        attach: function (context, settings) {
            var title = $('#search-wrapper');
            if ((typeof title !== 'undefined') && (title.length > 0)) {
                new UISearch(document.getElementById('search-wrapper'));
            }
        }
    };

    Drupal.behaviors.OysterThemeOpenNewWindow = {
        attach: function (context, settings) {
            $('.field-content .file a, .field__item .file a').once('file-clicked').click(function () {
                window.open(this.href);
                return false;
            });
        }
    };

    Drupal.behaviors.OysterThemeLazy = {
        attach: function (context, settings) {
            if ($.isFunction($.fn.Lazy)) {
                $(".lazy, .cta-image, .image-wrapper, .banner-image, .bg-image, .content img").Lazy();
            }
        }
    };

    $(window).on('load', function () {

        if ($.isFunction($.fn.waypoint)) {
            var sticky = new Waypoint.Sticky({
                element: $(' .header-wrapper')[0]
            }, {});
        }

        do_heights();

        load_map();

        //remove blank p tags
        $('.oyster_block_quote + p, .oyster_two_col + p, .oyster_three_col + p, .table-wrapper + p').each(function () {
            var $p = $(this),
                txt = $p.html();
            if (txt == '&nbsp;') {
                $p.remove();
            }
        });

        if (supportsES6 && location.hostname.match('dev.') == null) {
            var script = document.createElement("script");
            script.src = "/themes/custom/oystertheme/js/es6-scripts.js";
            document.body.appendChild(script);
        }
        
    });

    $(window).on('resize', function () {
        do_heights();
    });

    function do_heights() {
        $('.mobile-inactive .views-row .news-item').matchHeight();
        $('.mobile-inactive  .sub-menu-item').matchHeight();
        var webform_height = $('.webform-submission-contact-node-7-form').outerHeight();
        $('.mobile-inactive #block-contactusinfo').css('height', webform_height);
    }

    function load_map() {
        map_loader('contactmap-page');
        map_loader('contactmap-sidebar');
        map_loader('contactmap');
    }

    function map_loader( mapid){
        if ($('#'+ mapid).length > 0) {
            var map, loc, loc1, iconBase, marker;
            var markers = {};
            var infobox;
            var search_areas = [];
            var lat;
            var lng;
            var address;
            var popup;

            lat = drupalSettings.map_info.latitude;
            lng = drupalSettings.map_info.longitude;
            address = drupalSettings.map_info.address;
            popup = drupalSettings.map_info.popup;

            loc = new google.maps.LatLng(lat, lng);
            iconBase = '/themes/custom/oystertheme/images/';
            map = new google.maps.Map(document.getElementById(mapid), {
                zoom: 16,
                center: loc,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                scrollwheel: false,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false
            });

            //infobox
            infobox = new InfoBox({
                content: '<div id="infobox"></div>',
                disableAutoPan: false,
                maxWidth: 420,
                pixelOffset: new google.maps.Size(-150, -80),
                zIndex: null,
                enableEventPropagation: true,
                alignBottom: true,
                boxStyle: {
                    background: " url('" + iconBase + "pop.png') no-repeat  50% 100% ",
                    opacity: 1,
                    width: "300px"
                },
                closeBoxMargin: "10px 10px 2px 2px",
                closeBoxURL: "http://www.google.com/intl/en_us/mapfiles/close.gif",
                infoBoxClearance: new google.maps.Size(1, 1)
            });
            //map.set('styles', mapstyle);

            //loop through all the distributor markers
            var bounds3 = new google.maps.LatLngBounds();
            loc1 = new google.maps.LatLng(lat, lng);

            var icon_img = iconBase + 'pin.png';
            if($('body').hasClass('site-ukgcleaningcouk')){
                var icon_img = iconBase + 'pin-clean.png';
            }
            if($('body').hasClass('site-ukglifeskillscouk')){
                var icon_img = iconBase + 'pin-skills.png';
            }

            marker = new google.maps.Marker({
                map: map,
                position: loc1,
                visible: true,
                icon: icon_img
            });

            google.maps.event.addListener(marker, 'click', function () {
                if(mapid == 'contactmap-page'){
                    var thecontent = '<div id="infobox">' + popup + '</div>';
                }
                else {
                    var thecontent = '<div id="infobox">' + address + '</div>';
                }

                infobox.setContent(thecontent);
                infobox.open(map, this);
                map.panTo(loc1);
            });

            // markers.push(marker);
            bounds3.extend(marker.getPosition());

            //fit map to markers
            map.setCenter(bounds3.getCenter());
            if (map.getZoom() < 10) {
                //  map.setZoom(12);
            }
            //map.fitBounds(bounds3);
            map.setZoom(map.getZoom() - 1);

        }
    }

    var supportsES6 = function () {
        try {
            new Function("(a = 0) => a");
            return true;
        }
        catch (err) {
            return false;
        }
    }();

})(jQuery, window, Drupal);


